import { render } from "./SoberAnalyse.vue?vue&type=template&id=6fd05e6a&scoped=true&ts=true"
import script from "./SoberAnalyse.vue?vue&type=script&lang=ts"
export * from "./SoberAnalyse.vue?vue&type=script&lang=ts"

import "./SoberAnalyse.vue?vue&type=style&index=0&id=6fd05e6a&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd05e6a"]])

export default __exports__